module.exports = __webpack_public_path__ + "img/mSchoolsFooter@2x.6894691f.png";